import { Icon } from '@celito.clients/shared';
import { createTestAttribute } from '@celito.clients/utils';
import { mergeClasses, Text } from '@fluentui/react-components';

import { padLeftWithZero } from '../../../utils/helper';
import { wizardTypesStyles } from './types.styles';

const SuccessTypeSectionView: React.FC<{
  label: string;
  onClick: () => void;
  index: number;
}> = ({ label, onClick, index }) => {
  const styles = wizardTypesStyles();

  return (
    <div
      data-testid={`success-icon-container${label}`}
      className={mergeClasses(styles.section, styles.successType)}
      onClick={onClick}
    >
      <Text
        data-testid={`label-success-icon-${createTestAttribute(label)}`}
        className={styles.text}
      >
        {padLeftWithZero(index)} {label}
      </Text>
      <Icon iconName="Checkmark24Regular" />
    </div>
  );
};

export default SuccessTypeSectionView;
